module.exports = __webpack_public_path__ + "img/2374782-03-1.171ad657.png";